export default (() => {
  function toggleDownloadBrochure(e = false) {
      if(e) {
        e.preventDefault();
      }
      
      var wrapper = $('.notice-modal');
      var backdrop = $('#backdrop.notice-modal-control');

      if(wrapper.hasClass('open')) {
          wrapper.removeClass('open');
          backdrop.removeClass('active');
          return;
      }

      backdrop.addClass('active');
      wrapper.addClass('open');
  }

  $('.notice-modal-control').click(toggleDownloadBrochure);

  setTimeout(toggleDownloadBrochure(), 1000);
});



// WEBPACK FOOTER //
// ./scripts/components/notice-modal.js